import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Countdown = _resolveComponent("Countdown")!
  const _component_HeroBannerContent = _resolveComponent("HeroBannerContent")!
  const _component_HeroBanner = _resolveComponent("HeroBanner")!

  return (_openBlock(), _createBlock(_component_HeroBanner, {
    title: _ctx.title,
    "vimeo-id": _ctx.vimeoId?.toString(),
    image: _ctx.image,
    video: _ctx.nativeVideo,
    autoplay: _ctx.content.autoPlay,
    "text-color": _ctx.content.textHexColor
  }, {
    default: _withCtx(() => [
      (_ctx.isInCountdownMode)
        ? (_openBlock(), _createBlock(_component_Countdown, {
            key: "countdown",
            title: _ctx.content.campaign.countdownTopTitle,
            "expired-text": _ctx.content.campaign.expiredTitle,
            timer: _ctx.content.campaign.countDownTime,
            link: _ctx.content.campaign.countdownLink,
            class: "c-hero-banner__content"
          }, null, 8, ["title", "expired-text", "timer", "link"]))
        : (_openBlock(), _createBlock(_component_HeroBannerContent, {
            key: 1,
            content: _ctx.bannerContent,
            title: _ctx.title,
            "italic-bottom-title": _ctx.content.italicBottomTitle,
            "show-link-button": _ctx.isActiveCampaign
          }, null, 8, ["content", "title", "italic-bottom-title", "show-link-button"]))
    ]),
    _: 1
  }, 8, ["title", "vimeo-id", "image", "video", "autoplay", "text-color"]))
}